<template>
  <div class="face-result">
    <common-navbar v-if="$isFlag" :is-home-bar="true" />
    <van-loading v-if="loading" size="40px" vertical color="#0094ff" text-size="17px" class="jumpClass">正在跳转至支付宝</van-loading>
    <!-- 申诉成功提示 -->
    <div v-else>
      <div v-if="isFace === 1" class="identity-retrieval-four">
        <!-- <h5>亲爱的玩家，您当前的身份证未绑定雷霆账号。</h5> -->
        <h5>{{ `亲爱的玩家，您当前的身份证绑定了${bindPhoneList.length}个雷霆账号：` }}</h5>
        <ul>
          <li>雷霆账号</li>
          <li v-for="(item, i) in bindPhoneList" :key="i">{{ item }}</li>
        </ul>
        <div class="bottom">
          <van-button
            round
            block
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="handleWrite"
          >重新填写身份信息</van-button>
        </div>
        <div class="identity-retrieval-two__errortips">该身份证今日查询次数已达到上限，请明日再来</div>
        <div class="identity-retrieval-two__tips">
          <span>温馨提示：</span>
          <p>1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。</p>
          <p>2.若您已记起完整的账号，可以找回您的账号密码。</p>
        </div>
      </div>
      <p v-show="isFace == 0" class="notice">{{ noticeMsg }}</p>
      <div v-show="isFace == 2" class="appealResult">
        <img src="~assets/images/accountCenter/fail@2x.png" alt="">
        <p>人脸认证失败</p>
        <div class="btn">
          <van-button
            round
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="handleWrite"
          >手动绑定身份找回</van-button>
          <van-button
            round
            block
            type="info"
            color="#616edf"
            :disabled="disabled"
            class="formClass_btn"
            @click="faceAgain"
          >继续人脸找回</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import * as api from '@/api/account-self-manage/retrieval'
import commonNavbar from '@/views/accountCenter/common/commonNavbar'

export default {
  name: 'IdFaceResult',
  components: { commonNavbar },
  data() {
    return {
      disabled: false,
      show: true,
      loading: true,
      isFace: 0,
      noticeMsg: '',
      bindPhoneList: []
    }
  },
  created() {},
  mounted() {
    const { t, u } = this.$route.query
    const identityRetrievalUrl = this.$store.state.accountSelf.identityRetrievalUrl
    console.log(identityRetrievalUrl, t, u, 'awdwa')
    if (t && u) {
      Cookies.set('RETRIEVAL_TOKEN', t, { domain: 'leiting.com' })
      Cookies.set('RETRIEVAL_UID', u, { domain: 'leiting.com' })
      this.loading = false
      this.checkFace()
    } else {
      if (identityRetrievalUrl) {
        this.jumpStationUrl(identityRetrievalUrl)
        return
      }
      this.$msg('链接参数有误')
      this.noticeMsg = '链接参数有误'
      this.loading = false
    }
  },
  methods: {
    jumpStationUrl(url) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.style.target = '_blank'
      elink.href = url
      this.$store.dispatch('accountSelf/saveIdentityRetrievalUrl', '')
      setTimeout(() => {
        this.loading = false
        this.noticeMsg = '请在支付宝返回的页面进行操作'
      }, 3000)
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    handleWrite() {
      this.$router.push('/accountCenter/accountSelf/identityRetrieval')
    },
    checkFace() {
      api.check_face().then(res => {
        if (res.status == 0) {
          this.$ssd.track('leiting_idFaceResult_faceOk')
          this.isFace = 1
          this.bindPhoneList = res.data ? res.data : []
        } else {
          this.isFace = 2
          this.$ssd.track('leiting_idFaceResult_faceFail')
        }
      })
    },
    faceAgain() {
      api.get_face().then(res => {
        if (res.status == 0) {
          this.$msg('正在跳转至支付宝')
          this.jumpStationUrl(res.data)
        } else if (res.status == 50001) {
          this.$msg(res.message)
          this.disabled = true
        } else {
          this.$msg(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>
<style lang="stylus" scoped>
// h5
.face-result {
  position: relative
  z-index 99

  .notice{
      color: black;
      font-size: .3rem;
      margin-top: 4rem;
      text-align: center;
  }
  .jumpClass{
    width: 100%;
    z-index: 999;
    height: 100%;
    position: absolute;
    top: 2rem
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .appealResult {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .btn {
      display: flex;
      justify-content: space-between;

      .formClass_btn {
        width: 3.14rem;
        margin-right: 0.2rem;
        margin-top: 0.5rem;
      }
    }

    img {
      display: block;
      margin-top: 1rem;
      height: 3rem;
    }

    p {
      margin: 0.2rem;
      font-size: 0.34rem;
    }

    p:nth-child(2) {
      color: black;
    }

    p:nth-child(3) {
      color: #40BC40;
      position: relative;
    }

    p:nth-child(4) {
      font-size: 0.24rem;
      color: #B2B2B2;
      padding: 0 0.4rem;
      line-height: 0.4rem;

      span {
        color: #2dadea;
      }
    }
  }
  .identity-retrieval-four {
    padding-top: 1rem
    h5 {
      color: #5D5D5D
      font-size 0.28rem
      line-height 1.5
      text-align: center
    }
    ul {
      width: 100%
      padding: 0.32rem 0.4rem
      box-sizing: border-box
      li {
        width: 100%
        color: #5D5D5D
        font-size 0.26rem
        line-height 1.5
        text-align: center
        padding: 0.12rem 0
        box-sizing: border-box
      }
      li:nth-child(2n+1) {
        background-color #ECECEC
      }
    }
    .bottom {
      padding: 0.32rem 0.4rem
    }
    &__errortips {
      color: #FF3D3D
      font-size 0.26rem
      line-height 1.5
      text-align: center
    }
    &__tips {
      padding: 0.4rem 0 0
      span {
        color: #EB8D12
        display: block
        font-size 0.28rem
        line-height 2
      }
      p {
        color: #878787
        font-size 0.26rem
        line-height: 1.5
      }
    }
  }
}
</style>
